import FormattableTextField, { IFormattableTextFieldProps } from './FormattableTextField'

export default class PhoneNumberField extends FormattableTextField {
    public static defaultProps: Partial<IFormattableTextFieldProps> = {
        label: 'Telefoonnummer',
        required: false,
    }

    protected format(value: string = ''): string {
        return value.replace(/(^[+])?[^\d()\s-]*/gi, '$1').replace(/(.{0,16}).*/, '$1')
    }
}
